const CONFIGURED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const BACKEND_URL = process.env.NODE_ENV === "production" ? "" : CONFIGURED_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const authHeaders = (token) => ({
  "Content-Type": "application/json",
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
});

export const getScenes = async (token) => {
  const res = await fetch(`${API}/scenes`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: "include",
  });
  if (!res.ok) throw new Error(`Failed to fetch scenes: ${res.status}`);
  return await res.json();
};

export const activateScene = async (sceneId, token) => {
  const res = await fetch(`${API}/scenes/${sceneId}/activate`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: "include",
  });
  const payload = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(payload.detail || "Scene activation failed");
  return payload;
};

export const createScene = async (scene, token) => {
  const res = await fetch(`${API}/scenes`, {
    method: "POST",
    headers: authHeaders(token),
    credentials: "include",
    body: JSON.stringify(scene),
  });
  const payload = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(payload.detail || "Scene creation failed");
  return payload;
};

export const deleteScene = async (sceneId, token) => {
  const res = await fetch(`${API}/scenes/${sceneId}`, {
    method: "DELETE",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: "include",
  });
  const payload = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(payload.detail || "Scene deletion failed");
  return payload;
};

export const createSceneAutomation = async (sceneId, automation, token) => {
  const res = await fetch(`${API}/scenes/${sceneId}/automation`, {
    method: "POST",
    headers: authHeaders(token),
    credentials: "include",
    body: JSON.stringify(automation),
  });
  const payload = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(payload.detail || "Automation creation failed");
  return payload;
};